export default {
	methods: {
		async openDocument(documentUuid) {
			await this.$store
				.dispatch('documents/getEmployerDocumentUrl', documentUuid)
				.then((res) => {
					window.open(res.temporary_url, '_blank').focus();
				})
				.catch((error) => console.log(error));
		},
	},
}
